import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
// import { captchaValidator} from '../services/validators'

@Component({
  selector: 'app-calc-without-change-owner',
  templateUrl: './calc-without-change-owner.component.html',
  styleUrls: ['./calc-without-change-owner.component.css']
})
export class CalcWithoutChangeOwnerComponent implements OnInit {

  @ViewChild('selectRegion', {static: false}) public selectRegion: ElementRef;
  @ViewChild('selectCount', {static: false}) public selectCount: ElementRef;
  @ViewChild('btn', {static: false}) public btn: ElementRef;
  @ViewChild('divF', {static: false}) public firstF: ElementRef;
  @ViewChild('divS', {static: false}) public secondS: ElementRef;

  formErrors = {
    "depreg": "",
    "deptsc": "",
    "number": "",
    "depregcomb": "",
    "gender": "",
    "genderCh": "",
    "nz": "",
    "nzCh": ""
  };

  validationMessages = {
    "depreg": {
      "required": "Обов'якове поле.",
    },
    "depregcomb": {
      "required": "Обов'якове поле.",
      "captchaValidator": "Підтвердіть Recaptcha додатково.",
    },
    "depregcomb-two": {
      "required": "Обов'якове поле.",
    },
    "number": {
      "required": "Обов'якове поле.",
      "pattern": "Має бути ціле число.              ",
      "maxlength": "Максимум 4 числа.              ",
      "captchaValidator": "Підтвердіть Recaptcha додатково.",
    },
    "gender": {
      "pattern": "Обов'якове поле.",
    },
    "genderCh": {
      "pattern": "Обов'якове поле.",
    },
    "nz": {
      "pattern": "Обов'якове поле.",
    },
    "nzCh": {
      "pattern": "Обов'якове поле.",
    },
  };

  private DataRegion:any = [
    {
      seo_val: 0,
      text_val: '———————'
    },
    {
      seo_val: 2,
      text_val: 'Легковий'
    }, 
    {
      seo_val: 1,
      text_val: 'Вантажний'
    }, 
    {
    seo_val: 0,
    text_val: 'Автобус'
    }, 
    {
    seo_val: 3,
    text_val: 'Мотоцикл'
    }, 
    {
    seo_val: 4,
    text_val: 'Мопед'
    },
    {
    seo_val: 5,
    text_val: 'Причіп (напівпричіп)'
    }
  ]

  private DataCount:any = [
    {
      seo_val: 0,
      text_val: '—————'
    },
    {
      seo_val: '1',
      text_val: 'Так'
    }, 
    {
      seo_val: '0',
      text_val: 'Ні'
    }
  ];

  private nzChooseType:any = [
    {
      seo_val: '0',
      text_val: 'білі для легкових ТЗ (4 цифри, фіз. особа)'
    }, 
    {
      seo_val: '0',
      text_val: 'білі для легкових ТЗ (4 цифри, юр. особа)'
    }, 
    {
      seo_val: '0',
      text_val: 'білі для вантажних ТЗ (4 цифри, фіз. особа)'
    }, 
    {
      seo_val: '0',
      text_val: 'білі для вантажних ТЗ (4 цифри, юр. особа)'
    }, 
    {
      seo_val: '0',
      text_val: 'білі для причепів (4 цифри)'
    }, 
  ]

  private nzCombination:any = [
    {
      seo_val: 0,
      text_val: 'Оберіть вартість бажаного номерного знаку (з урахуванням ПДВ)'
    }, 
    {
      seo_val: 30000,
      text_val: '36000 грн - із чотирьох однакових цифр'
    }, 
    {
      seo_val: 30000,
      text_val: '36000 грн - послідовні комбінації цифр від 0001 до 0009'
    },
    {
      seo_val: '10000',
      text_val: '12000 грн - із чотирьох цифр, три з яких однакові та розташовані підряд'
    },
    {
      seo_val: '10000',
      text_val: '12000 грн - із чотирьох цифр - двох послідовних пар однакових цифр'
    },
    {
      seo_val: '10000',
      text_val: '12000 грн - з послідовних цифр 0123 або 1234'
    },
    {
      seo_val: '8000',
      text_val: '9600 грн - із чотирьох цифр, що починається з двох нулів, а дві наступні цифри неоднакові'
    },
    {
      seo_val: '4000',
      text_val: '4800 грн - із чотирьох цифр, що містить три однакові цифри, які розташовані не підряд'
    },
    {
      seo_val: '4000',
      text_val: '4800 грн - із чотирьох цифр, з яких однаковими є перша і третя, а також друга і четверта, або перша і четверта, а також друга і третя'
    }
  ]

  getDataRegion() {
    return this.DataRegion;
  }

  getDataCount() {
    return this.DataCount;
  }

  getNzComb() {
    return this.nzCombination;
  }
  getNzChooseComb() {
    return this.nzChooseType;
  }

  dropDownDataRegion:any = [];
  dropDownDataCount:any = [];
  dropDownNzComb:any = [];
  dropDownNzChooseComb:any = [];

  sum:number = 0;
  fainsDu:number = 0;
  fainsNz:number = 0;
  sellCount:number = 0;
  nz_price: number = 0;
  name: string;
  name_inozemn_vit:string;
  arr_poslug_price: number = 0;
  nz_full:number = 0;

  add_nz_price:number = 336;  // було 180
  svidoc_price:number = 312;  // було 312
  poslug_sum:number = 200;

  addData: FormGroup;


  constructor(private fb: FormBuilder, private router: Router) { }

  ngOnInit() {
    this.buildFormComb();

    this.dropDownDataRegion = this.getDataRegion();
    this.dropDownDataCount = this.getDataCount();
    this.dropDownNzComb = this.getNzComb();
    this.dropDownNzChooseComb = this.getNzChooseComb();

    document.getElementById('nz-change').style.display = "none";
    // document.getElementById('check-lang').style.display = "none";
  }

  resolvedD(captchaResponse: string) {

    if (captchaResponse != '') {

      localStorage.setItem("verified", "true");
      this.addData.controls['depregcomb'].updateValueAndValidity();
      this.btn.nativeElement.className = "button_success";
      
    } else { alert('Ooops! Something go wrong!')}
  }

  buildFormComb() {
    this.addData = this.fb.group({
      "depregcomb": ['', [
        Validators.required, 
    ]],
    "depregcomb-two": ['', [
         
  ]],
      "number": ['', [
        Validators.pattern("\\d+"),
    ]],
      "gender": ['', [
        
    ]],
    "genderCh": ['', [
        
    ]],
    "nz": ['', [
      
    ]],
    "nzCh": ['', [
      
    ]]
    });

    this.addData.valueChanges
    .subscribe(data => this.onValueChangeComb(data));

    this.onValueChangeComb();

  }

  onValueChangeComb(data?: any) {

    if (!this.addData) return;
    let form = this.addData;

    for (let field in this.formErrors) {
        this.formErrors[field] = "";
      
        let control = form.get(field);

        if (control && control.dirty && !control.valid) {
            let message = this.validationMessages[field];
            for (let key in control.errors) {
                this.formErrors[field] += message[key] + " ";
            }
        }
    }
  } 

  onOptionsSelectedRegion(value:string) {
    if (+value == 2) {
      document.getElementById('nz-change').style.display = "block";
    } else {
      document.getElementById('nz-change').style.display = "none";
    }
  }

  onOptionsSelectedChangeNz(value:string) {
    if (+value == 1) {
      document.getElementById('nz-comb-yn').style.display = "block";
      this.add_nz_price = 336;
    } else {
      document.getElementById('nz-comb-yn').style.display = "none";
      this.add_nz_price = 0;
    }
  }

  onOptionsSelectedNz(value:string) {
    if (+value == 1) {
      document.getElementById('choose-nz').style.display = "block";
    } else {
      document.getElementById('choose-nz').style.display = "none";
    }
  }

  get myForm() {
    return this.addData.get('gender');
  }

  backClicked() {
    /*  this._location.back(); */
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this.router.navigate(['calculator-w-change-owner']);
    });
    localStorage.removeItem("verified");
  }

  backMainClicked() {
    /*  this._location.back(); */
    this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
    this.router.navigate(['/']);
    });
    localStorage.removeItem("verified");
  }

  fetchDnzNumb(region:any, nzMoney:any) {

    const enterParam: HTMLElement = document.getElementById('first');
    const outData: HTMLElement = document.getElementById('second');

    enterParam.classList.add('animate__animated', 'animate__zoomOut');
    setTimeout(() => enterParam.hidden = true, 900);

    outData.classList.add('animate__animated', 'animate__flipInY');
    setTimeout(() => document.getElementById('second').style.display = 'block', 900);

    let nums = +region;

    switch (nums) {
      case 0:
          this.name = 'автобуса';
          this.nz_price = nzMoney;
          this.nz_full = this.add_nz_price + this.fainsNz + this.nz_price;
          this.fainsDu = 0;
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.sum = this.arr_poslug_price + Math.ceil(this.nz_full) + this.svidoc_price;
          break;
      case 1: 
          this.name = 'вантажного ТЗ';         
          this.fainsDu = 0;
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.nz_full = this.add_nz_price + this.fainsNz + this.nz_price;
          this.sum = this.arr_poslug_price + Math.ceil(this.nz_full) + this.svidoc_price;
          break;
      case 2:
          this.name = 'легкового ТЗ';
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.nz_price = +nzMoney;
          this.fainsNz = nzMoney*0.2;
          this.nz_full = this.add_nz_price + this.fainsNz + this.nz_price;
          let rezult = this.arr_poslug_price + Math.ceil(this.nz_full) + this.svidoc_price;
          this.sum = Math.ceil(rezult);
          break;
      case 3:
          this.name = 'мотоцикла';
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.nz_full = 111;  // номерний знак, округлено, було 74
          this.fainsDu = 0;
          this.sum = this.arr_poslug_price + Math.ceil(this.nz_full) + this.svidoc_price;
          break;
      case 4:
          this.name = 'мопеда';
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу
          this.fainsDu = 0;
          this.nz_full = 84;  // номерний знак, округлено, було 60
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу

          this.sum = this.arr_poslug_price + Math.ceil(this.nz_full) + this.svidoc_price;
          break; 
      case 5:          
          this.name = 'причіпа (напівпричіпа)';
          this.fainsDu = 0;
          this.nz_full = 101; // номерний знак, округлен, обуло 90
          this.arr_poslug_price = Math.ceil(this.poslug_sum); // округлена сума за послугу

          this.sum = this.arr_poslug_price + Math.ceil(this.nz_full) + this.svidoc_price;
          break;                                          
      default:
          console.log("No such numb exists!");
          break;
  }

}


}
